import { css } from '@emotion/react';
import { theme } from 'global';

export const navButtonsWrapper = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 40px;

  .backButton {
    margin: 0;
    padding: 0;
    min-width: auto;
    justify-content: flex-start;
  }

  .backButton:hover,
  .backButton:active,
  .backButton:focus {
    background: none;
    box-shadow: none;
  }

  .continueButton {
    min-width: fit-content;
    margin-left: auto;
  }

  @media screen and (max-width: ${theme.breaks.xs}px) {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    padding: 16px;
    margin-top: 0;
    z-index: 1000;
    border-top: 1px solid ${theme.colors.neutral[100]};
  }
`;
